import { Injectable } from '@angular/core';
import { Filter, FilterItem, FiltersEditedItems } from '../models/Contact';
import {
  GetFilterItemsSuccessAction,
  SetFilteringByFilterItemAction,
  TakeEditingFilterSnapshot,
  UpdateTempEditedFilterList
} from '../../contacts.actions';
import { Store } from '@ngrx/store';
import { IState } from '../../../shared/models/state';

@Injectable()
export class FilterService {
  constructor(private store: Store<IState>) {}

  updateStoreFilterData(
    filterItemsListToRequest: Filter,
    listOfFilterItems: FiltersEditedItems | FilterItem[],
    editedFiltersList: string[],
    filter: string
  ) {
    this.updateStoreEditedFiltersList(filterItemsListToRequest, editedFiltersList, filter);
    this.updateStoreRequestFilters(filterItemsListToRequest, filter);
    this.updateSwitchView(listOfFilterItems, filter);
  }

  updateStoreEditedFiltersList(ItemsListToRequest, tempEditedFiltersList, filter) {
    if (ItemsListToRequest.length) {
      const editedFilters = this.getEditedFiltersListUpdate(filter, tempEditedFiltersList);
      this.store.dispatch(new UpdateTempEditedFilterList(editedFilters));
    } else {
      const reducedFilterList = tempEditedFiltersList ? tempEditedFiltersList.filter(el => el !== filter) : [];
      this.store.dispatch(new UpdateTempEditedFilterList(reducedFilterList));
    }
  }

  updateStoreRequestFilters(list, filter: string) {
    this.store.dispatch(
      new SetFilteringByFilterItemAction(
        list.length ? { collection: list, filter: filter } : { collection: null, filter: filter }
      )
    );
  }

  updateSwitchView(list, filter) {
    this.store.dispatch(new GetFilterItemsSuccessAction({ list: list, filterName: filter }));
  }

  getEditedFiltersListUpdate(filter: string, list: string[]) {
    if (!!list && !list.includes(filter)) {
      list.push(filter);
    }

    return list;
  }

  getFilterSnapshot() {
    this.store.dispatch(new TakeEditingFilterSnapshot());
  }
}
